import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

export class ShippingPricelist {

    static _JSONProps: string[] = [
        'id',
        'carrier_code',
        'package_type',
        'max_weight',
        'country_code',
        'price',
        'is_flex',
        'is_business',
        'is_droppoint',
    ];

    id?: string;
    carrier_code?: string;
    package_type?: string;
    max_weight?: number;
    country_code?: string;
    price?: number;
    is_flex?: boolean;
    is_business?: boolean;
    is_droppoint?: boolean;
    created?: Moment;
    modified?: Moment;

    static fromJSON(json: ShippingPricelistJSON | string): ShippingPricelist {
        if (json === null || json === undefined) {
            return new ShippingPricelist();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, ShippingPricelist.reviver);
        } else {
            const shippingPricelist = Object.create(ShippingPricelist.prototype);

            const extra = {
                modified: json.modified ? moment(json.modified) : null,
                created: json.created ? moment(json.created) : null,
            };

            Object.keys(json).forEach((key) => {
                if (ShippingPricelist._JSONProps.indexOf(key) !== -1) {
                    shippingPricelist[key] = json[key];
                }
            });

            return Object.assign(shippingPricelist, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === '' ? ShippingPricelist.fromJSON(value) : value;
    }

    constructor(initializer?: ShippingPricelistJSON) {
        if (initializer === undefined) {
            return;
        }
    }
}

export interface ShippingPricelistJSON {
    id?: string;
    carrier_code?: string;
    package_type?: string;
    max_weight?: number;
    country_code?: string;
    price?: number;
    is_flex?: boolean;
    is_business?: boolean;
    is_droppoint?: boolean;
    created?: string | Moment;
    modified?: string | Moment;
}
